import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from '@/components/ui/table';
import {
	flexRender,
	Table as ReactTable,
} from '@tanstack/react-table';
import {
	LoaderCircle,
} from 'lucide-react';

interface DataTableProps<TData> {
	table: ReactTable<TData>;
	isFetching?: boolean;
	noResultsMessage?: string;
	className?: string;
}

export function DataTable<TData>({
	table,
	isFetching = false,
	noResultsMessage = "No results.",
	className = "rounded-md border",
}: DataTableProps<TData>) {
	if (isFetching) {
		return (
			<div className="flex items-center justify-center py-10">
				<LoaderCircle size={40} className="animate-spin" />
			</div>
		);
	}

	return (
		<div className={className}>
			<Table>
				<TableHeader>
					{table.getHeaderGroups().map((headerGroup) => (
						<TableRow key={headerGroup.id}>
							{headerGroup.headers.map((header) => {
								return (
									<TableHead key={header.id}>
										{header.isPlaceholder
											? null
											: flexRender(header.column.columnDef.header, header.getContext())}
									</TableHead>
								);
							})}
						</TableRow>
					))}
				</TableHeader>
				<TableBody>
					{table.getRowModel().rows?.length ? (
						table.getRowModel().rows.map((row) => (
							<TableRow key={row.id} data-state={row.getIsSelected() && 'selected'}>
								{row.getVisibleCells().map((cell) => (
									<TableCell key={cell.id}>
										{flexRender(cell.column.columnDef.cell, cell.getContext())}
									</TableCell>
								))}
							</TableRow>
						))
					) : (
						<TableRow>
							<TableCell colSpan={table.getAllColumns().length} className="h-24 text-center">
								{noResultsMessage}
							</TableCell>
						</TableRow>
					)}
				</TableBody>
			</Table>
		</div>
	);
}